import BaseRepository    from 'Domain/Repository/BaseRepository/BaseRepository';
import { FileReference } from 'Domain/Model/FileReference/FileReference';

const config = {
  model    : FileReference,
  baseRoute: '/file-reference',
  singular : 'fileReference',
  plural   : 'fileReferences',
};

class FileReferenceRepository extends BaseRepository<FileReference, typeof config.singular, typeof config.plural> {

}

export default new FileReferenceRepository(config);
